<template>
  <b-modal
    centered
    no-close-on-backdrop
    id="entrance-dublicate-modal"
    title="Дублирование подъездов"
    :ok-title="$t('generals.save')"
    :cancel-title="$t('generals.cancel')"
    @ok.prevent="dublicateEntrance"
  >
    <b-form-group :label="$t('objects.object')">
      <v-select
        :options="GET_OBJECTS"
        :get-option-label="(object) => object.title"
        :reduce="(object) => object.id"
        v-model="dublicate.object"
        @input="getApartments"
      />
    </b-form-group>
    <b-form-group :label="$t('navbars.home')">
      <v-select
        :options="GET_APARTMENTS"
        :get-option-label="(apartment) => apartment.title"
        :reduce="(apartment) => apartment.id"
        v-model="dublicate.apartment"
        :disabled="!dublicate.object"
        @input="getSections"
      />
    </b-form-group>
    <b-form-group :label="$t('objects.entrance')">
      <v-select
        :options="GET_APARTMENT_SECTIONS_FOR_SELECT"
        :get-option-label="(section) => section.title"
        :reduce="(section) => section.id"
        v-model="dublicate.section"
        :disabled="!dublicate.apartment"
      />
    </b-form-group>
  </b-modal>
</template>

<script>
import LazySelect from "@/components/LazySelect.vue";
import { BModal, BFormGroup } from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";
import VSelect from "vue-select";

export default {
  name: "EntranceDublicate",
  components: {
    BModal,
    BFormGroup,
    LazySelect,
    VSelect,
  },

  data() {
    return {
      dublicate: {
        object: null,
        apartment: null,
        section: null,
        stage: 0,
      },
    };
  },

  computed: {
    ...mapGetters("objects", ["GET_OBJECTS"]),
    ...mapGetters("apartments", ["GET_APARTMENTS"]),
    ...mapGetters("sections", ["GET_APARTMENT_SECTIONS_FOR_SELECT"]),
  },

  methods: {
    ...mapActions("objects", ["FETCH_OBJECTS"]),
    ...mapActions("apartments", ["FETCH_APARTMENTS_BY_OBJECT"]),
    ...mapActions("sections", [
      "FETCH_APARTMENT_SECTIONS_FOR_SELECT",
      "DUBLICATE_SECTION",
    ]),

    async getApartments(id) {
      this.dublicate.apartment = null;
      this.dublicate.section = null;
      if (!id) return;

      try {
        await this.FETCH_APARTMENTS_BY_OBJECT({ id });
      } catch (error) {
        this.$_errorToast(
          error?.response?.data?.message || this.$t("generals.error")
        );
      }
    },

    async getSections(id) {
      this.dublicate.section = null;
      if (!id) return;

      try {
        await this.FETCH_APARTMENT_SECTIONS_FOR_SELECT(id);
      } catch (error) {
        this.$_errorToast(
          error?.response?.data?.message || this.$t("generals.error")
        );
      }
    },

    async dublicateEntrance() {
      try {
        const { object, apartment, ...rest } = this.dublicate;
        await this.DUBLICATE_SECTION({
          apartment: Number(this.$route.params.id),
          ...rest,
        });
        this.$bvModal.hide("entrance-dublicate-modal");
        this.$_successToast(this.$t("generals.dublicate"));
      } catch (error) {
        console.log(error);
        this.$_errorToast(
          error?.response?.data?.message || this.$t("generals.error")
        );
      }
    },
  },

  mounted() {
    this.FETCH_OBJECTS();
  },
};
</script>
